<!-- 하단 고정 FOMO 바 -->
<div class="fomo-bottom-bar">
  <div class="fomo-bottom-inner">
    <!-- 좌측: 아이콘 + 텍스트 -->
    <div class="fomo-bottom-content">
      <span class="icon-[material-symbols--groups] fomo-icon"></span>
      <p class="fomo-bottom-text">
        <span class="fomo-bottom-count">{{ count() }}명</span>의 예비 투자자들이 주관증권사를 기다립니다
      </p>
    </div>

    <!-- 우측: 강조 뱃지 -->
    <div class="fomo-bottom-badge">
      <span class="icon-[material-symbols--schedule]"></span>
      대기 중
    </div>
  </div>
</div>
